import React, { useCallback, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { translate } from '@td/shared_utils';
import { ExpandableTextInput } from "@td/ui";
import styles from './styles.module.scss';

const DEFAULT_VALUE = '';
const ENTER_KEY = 'Enter';

const ChecklistItemForm = ({ onSubmit }) => {
  const [value, setValue] = useState(DEFAULT_VALUE);
  const textInput = useRef(null);

  const onChange = useCallback(({ target: { value: input } }) => setValue(input), []);

  const onKeyPress = useCallback(event => {
    if (event.key === ENTER_KEY) {
      event.currentTarget.blur();
      const trimmedValue = value.trimEnd();

      if (trimmedValue) {
        onSubmit(value);
      }

      setValue(DEFAULT_VALUE);
    }
  }, [value, onSubmit]);

  return (
    <ExpandableTextInput
      className={styles.checklistFormField}
      value={value}
      onChange={onChange}
      onKeyPress={onKeyPress}
      placeholder={translate(null, "care_team_tasks.form.fields.checklist", "placeholder")}
      ref={textInput}
    />
  );
};

ChecklistItemForm.propTypes = {
  onSubmit: PropTypes.func.isRequired
};

export default ChecklistItemForm;
